import { http } from "Utils/http";
import { httpDownload } from "Utils/httpDownload";
import {STATUSES, USER_ROLES} from "Utils/constants";
import {store} from "../../../Store";

// trigger pwd reset email
const resetPassword = async (token, userId, password, tokenType) => {

  let status = STATUSES.SUCCESS;
  // ResetPasswordRequest.java
  let body = {
    "userId": userId,
    "password": password,
    "tokenType": tokenType
  };

  //console.log("resetPassword() body", body);
  const url = "/api/manage/users/resetpassword";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {

    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// generate account status report
const generateAccountStatusRpt = async (token) => {

  let status = STATUSES.SUCCESS;
  const isPSOPPCAdmin = store.getState().loginInfo.role === USER_ROLES.PSOPPCADMIN.id;
  // reference to StatusReportRequest.java
  let body = {
    statusIdList: [21, 22, 24],
    statusNameList: ["Active", "Inactive", "Terminated"],
    reportFileName: isPSOPPCAdmin ? "Account Status Report" : "PSO Account Status Report"
  }

  const url = "/api/report/accountStatus";
  const res = await httpDownload.post(url, body, {
    responseType: "blob",
    headers: {
      "Authorization": token
    }
  }).then((res) => {
    //console.log("generateAccountStatusRpt", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {

    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

export { resetPassword, generateAccountStatusRpt }; 